// extracted by mini-css-extract-plugin
module.exports = {"xlArr":"RightArrow_xlArr__3ItNm","lgArr":"RightArrow_lgArr__3fQTq","smArr":"RightArrow_smArr__Lbcap"};